import { TextField } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

import useStyles from "./useStyles";

/**
 * 日付テキストフィールドコンポーネント.
 *
 * @param {string} label ラベル
 * @param {string} value 値
 * @param {function} onChange 値が変化したときの処理
 * @param {function} onClick 値をクリックしたときの処理
 * @param {object} items 選択アイテム
 * @return {object} コンポーネント
 */
function DateTextField(props) {
  // 引数
  const {
    // ラベル
    label,
    // スタイル
    variant,
    // 値
    value,
    // 値が変化したときの処理
    onChange,
    // データ形式
    type,
  } = props;

  // スタイル
  const styles = useStyles();

  return (
    <TextField
      className={styles.dateFiled}
      type={type}
      label={label}
      variant={variant}
      value={value}
      onChange={onChange}
    />
  );
}

DateTextField.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["standard", "filled", "outlined"]),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  type: PropTypes.oneOf(["date", "time", "datetime-local"]),
};

DateTextField.defaultProps = {
  variant: "standard",
  onChange: () => ({}),
  type: "date",
};

export default DateTextField;
